import { UserModel } from '@/features/tenant-manager/models';
import { t } from '@/i18n';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

const workflowApprovalStateType = z.enum(['reviewing', 'approved', 'rejected']);
export const WorkflowApprovalStateTypeLabelModifier = {
  reviewing: t('unapproved'),
  approved: t('approved'),
  rejected: t('reject'),
} as const satisfies Record<z.infer<typeof workflowApprovalStateType>, string>;

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const WorkflowApprovalModel = z.object({
  id: z.string().uuid(),
  stageId: z.string().uuid(),
  approverId: z.string().uuid().nullable(),
  approver: UserModel,
  state: workflowApprovalStateType,
  comment: z.string().nullable(),
  approvedAt: z.string().nullable(),
  isMe: z.boolean(),
});

export const ApprovalDecisionFormSchema = z.object({
  type: z.enum(['approve', 'reject']),
  comment: z.string().min(1),
});

export const ApprovalDecisionRequestSchema = ApprovalDecisionFormSchema.extend({
  id: z.string(),
  workflowId: z.string(),
  stageId: z.string(),
});

export const ApprovalReviewFormSchema = ApprovalDecisionFormSchema.pick({
  comment: true,
});

export const ApprovalReviewRequestSchema = ApprovalDecisionRequestSchema.omit({
  type: true,
});
